"use client";

import { FC } from "react";

import classNames from "classnames";
import dompurify from "isomorphic-dompurify";

import { BUILDER_TEXT_CLASSNAME } from "@/libs/builder/consts";

import { richTextInputs } from "./RichText.builder";

import styles from "./RichText.module.scss";

const { sanitize } = dompurify;

export type RichTextProps = BuilderComponentProps<typeof richTextInputs>;

export const RichText: FC<RichTextProps> = ({ text }) => {
  if (!text) {
    return null;
  }

  return (
    <div
      className={classNames(BUILDER_TEXT_CLASSNAME, styles.richText)}
      dangerouslySetInnerHTML={{
        __html: sanitize(text, {
          ADD_ATTR: ["target"],
        }),
      }}
    />
  );
};
